/* eslint-disable */

export const state = () => ({
  list: [],
  loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 09 Aug 2023 | 05:43PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),

  /**
   * @description
   * @author Saurabh Jangra
   * @date 09 Aug 2023 | 05:43PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value)
};

export const actions = {
  fetchNewNotification(__, payload) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription { get_new_notification }`,
        variables: { payload }
      });
      for await (const event of _result) {
        if (event?.data?.get_new_notification?.message) this.$toaster.success(event?.data?.get_new_notification?.message);
      }
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading
};
